// Корень приложения: провайдеры и маршрутизатор. При старте поднимается прошлая сессия
// по токену обновления, чтобы человек не вводил фразу после каждой перезагрузки страницы.

import { useEffect } from 'react';

import { RouterProvider } from 'react-router/dom';

import { restoreSession } from '@/shared/auth/session';
import { отметитьЗапуск } from '@/shared/desktop/что-нового';
import { следитьЗаСредой } from '@/shared/среда';
import { выбраннаяТема, применитьТему, следитьЗаСистемой } from '@/shared/theme';
import { ПлашкаОбновления } from '@/layout/ПлашкаОбновления';

import { Providers } from './providers';
import { router } from './router';

// Запуск этой версии отмечается ДО первого кадра, при загрузке модуля. Позже программа сама
// пишет в память устройства (вход, кэш экранов), и тогда первая установка стала бы неотличима
// от обновления: человек, поставивший программу впервые, получил бы «Что нового» о том, чего
// он и старым не видел.
отметитьЗапуск();

export function App() {
  useEffect(() => {
    // Повторный вызов (строгий режим React в разработке) присоединяется к тому же
    // промису: восстановление single-flight, второго запроса к серверу не будет.
    void restoreSession();
  }, []);

  // Тема ставится ДО первого кадра содержимого и в одном месте на всё приложение. Пока
  // класса `dark` не вешал никто, тёмная тема была нарисована целиком и не показывалась
  // ни разу. Слежка нужна вживую: человек переключает тему Windows по расписанию.
  useEffect(() => {
    применитьТему(выбраннаяТема());
    return следитьЗаСистемой(выбраннаяТема);
  }, []);

  // Ширина окна, палец или мышь, есть ли клавиатура — признаками на корне страницы. Здесь же,
  // рядом с темой, и по той же причине: это свойства всего сеанса, а не экрана. Планшет
  // меняет их на ходу — поворотом, разделением экрана, подключением клавиатуры.
  useEffect(() => следитьЗаСредой(), []);

  return (
    <Providers>
      {/* Высоту окна держит ЭТА колонка, а не сами экраны: полоса обновления встаёт под
          содержимым, а не поверх него. Поверх она закрывала бы подвал списка — а там живут
          массовые действия над выделенными строками, и нажатие в них про деньги.

          Полоса стоит ВЫШЕ маршрутизатора намеренно, а не внутри защищённой области. Программа
          у финансового директора открыта неделями, и сессия в ней успевает протухнуть за ночь:
          внутри защищённой области обновление переставало бы искаться ровно тогда, когда окно
          висит на экране входа. */}
      <div className='flex h-приложение w-full flex-col overflow-hidden'>
        <div className='min-h-0 flex-1 overflow-hidden'>
          <RouterProvider router={router} />
        </div>
        <ПлашкаОбновления />
      </div>
    </Providers>
  );
}
